import React from "react";
import { Form } from "rsuite";
import styled from "styled-components";

import { FilterSectionFlexboxGrid, StyledItemFitWidth } from "components/base/FitContainers";
import CheckboxFullControl from "components/Form/CheckboxFullControl";
import CustomField from "components/Form/CustomField";



const AccountManagersFilter = ({ filters, setFilters, isMobile }) => {
    return <FilterSectionFlexboxGrid isMobile={isMobile}>
        <StyledItemFitWidth isMobile={isMobile} controlable={!isMobile} group mr={20}>
            <StyledForm
                layout="inline"
                formValue={filters}
                onChange={setFilters}
            >
                <CustomField
                    name="str"
                    width={isMobile ? "100%" : "360px"}
                    style={{ marginBottom: 0 }}
                    placeholder="AM, Email, Team Lead, AM from billing, Users"
                />
                <CustomField
                    accepter={CheckboxFullControl}
                    name="show_only_active"
                >
                    Show only active managers
                </CustomField>
            </StyledForm>
        </StyledItemFitWidth>
    </FilterSectionFlexboxGrid>
};

export default AccountManagersFilter;

const StyledForm = styled(Form)`
    .rs-form-group {
        margin-bottom: 0px;
    }
`;